<script setup lang="ts">
</script>

<!-- eslint-disable -->
<template>
    <svg width="411" height="358" viewBox="0 0 411 358" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3357_29805)">
            <path opacity="0.8" d="M230.759 254.425C116.364 260.967 30.7774 199.677 0 167.047V-0.000244141H411V339C386.359 291.806 345.154 247.883 230.759 254.425Z" fill="#C7F2E8"/>
        </g>
        <defs>
            <clipPath id="clip0_3357_29805">
                <rect width="411" height="358" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>
<!-- eslint-enable -->
